export const LANDING = "welcome" as const

export const PROJECTS = "projects" as const
export const PROJECT_DETAILS = "project-details" as const
export const SHARED_PROJECT_DETAILS = "shared-project-details" as const

export const FAVORITES = "favorites" as const
export const PRODUCT = "product" as const
export const PORTFOLIO = "portfolio" as const
export const BUILDING_REFERENCES = "references" as const
export const REFERENCE_REDIRECT = "reference-redirect" as const
export const NOT_FOUND = "not-found" as const
export const PRODUCT_CONFIGURATION = "product-configuration" as const

export const MISSING_EMAIL_VERIFICATION = "missing-email-verification" as const
export const POST_EMAIL_VERIFICATION = "post-email-verification" as const

export const TEAM_DETAILS = "team-details" as const
export const REGISTER = "register" as const
